import React, { FC } from 'react';
import { MessageWithCloseButton } from './MessageWithCloseButtonModal';
import { useTranslation } from 'react-i18next';
import './UnexpectedErrorModal.scss';

type NetworkErrorModalProps = {
  jsonBlob?: string;
  show: boolean;
  errorCode?: number;
  onClose: () => void;
};

export const NetworkErrorModal: FC<NetworkErrorModalProps> = ({ jsonBlob, show, errorCode, onClose }) => {
  const i18next = useTranslation();
  const errorData = !jsonBlob ? {} : JSON.parse(jsonBlob);

  const { title, message } =
    errorCode === 403
      ? {
          title: 'common.forbiddenTitle',
          message: i18next.t('common.forbiddenMessage')
        }
      : { title: 'unexpectedNetworkError', message: 'recoverableErrorMessage' };

  return (
    <div className="unexpected-error-modal">
      <MessageWithCloseButton i18KeyForTitle={title} i18KeyForMessage={message} onClose={onClose} show={show}>
        <ul>
          {Object.keys(errorData).map((key) => (
            <li key={key}>
              <div>{key}</div>
              <ul>
                {(errorData[key] ?? []).map((value: string) => (
                  <li key={`${value}`}>{value}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </MessageWithCloseButton>
    </div>
  );
};
